import { render, staticRenderFns } from "./noticeCompany.vue?vue&type=template&id=2cfbe91a&scoped=true&"
import script from "./noticeCompany.vue?vue&type=script&lang=js&"
export * from "./noticeCompany.vue?vue&type=script&lang=js&"
import style0 from "./noticeCompany.vue?vue&type=style&index=0&id=2cfbe91a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbe91a",
  null
  
)

export default component.exports